interface PartnerCardProps {
  partner: { id: number; name: string; logo: string; website: string; order: number; visible: boolean };
  index: number;
  total: number;
  onDelete: (id: number) => void;
  onToggleVisible: (id: number) => void;
  onMoveUp: (id: number) => void;
  onMoveDown: (id: number) => void;
  onEdit: (partner: any) => void;
}

export default function PartnerCard({
  partner,
  index,
  total,
  onDelete,
  onToggleVisible,
  onMoveUp,
  onMoveDown,
  onEdit,
}: PartnerCardProps) {
  return (
    <div
      className={`bg-white rounded-2xl border-2 transition-all duration-200 hover:scale-[1.01] ${
        partner.visible ? 'border-rose-100 hover:border-rose-200' : 'border-gray-200 opacity-60'
      }`}
    >
      {/* Order badge + visibility */}
      <div className="flex items-center justify-between px-4 pt-3 pb-1">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full bg-rose-50 border-2 border-rose-100 text-xs font-bold text-rose-400">
            {index + 1}
          </span>
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${
            partner.visible
              ? 'bg-emerald-50 text-emerald-600 border-emerald-200'
              : 'bg-gray-100 text-gray-400 border-gray-200'
          }`}>
            {partner.visible ? 'מוצג' : 'מוסתר'}
          </span>
        </div>

        {/* Move up/down */}
        <div className="flex items-center gap-1">
          <button
            onClick={() => onMoveUp(partner.id)}
            disabled={index === 0}
            className="w-7 h-7 flex items-center justify-center rounded-lg border-2 border-rose-100 bg-rose-50 text-rose-400 hover:bg-rose-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
          >
            <i className="ri-arrow-up-s-line text-sm"></i>
          </button>
          <button
            onClick={() => onMoveDown(partner.id)}
            disabled={index === total - 1}
            className="w-7 h-7 flex items-center justify-center rounded-lg border-2 border-rose-100 bg-rose-50 text-rose-400 hover:bg-rose-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
          >
            <i className="ri-arrow-down-s-line text-sm"></i>
          </button>
        </div>
      </div>

      {/* Logo */}
      <div className="mx-4 my-3 h-20 rounded-xl border-2 border-rose-50 bg-rose-50/40 overflow-hidden flex items-center justify-center">
        <img
          src={partner.logo}
          alt={partner.name}
          className="w-full h-full object-contain p-2"
        />
      </div>

      {/* Name + website */}
      <div className="px-4 pb-3">
        <p className="font-bold text-gray-800 text-sm text-center">{partner.name}</p>
        {partner.website && (
          <p className="text-xs text-gray-400 text-center truncate mt-0.5">{partner.website}</p>
        )}
      </div>

      {/* Actions */}
      <div className="flex gap-2 px-4 pb-4">
        <button
          onClick={() => onEdit(partner)}
          className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border-2 border-rose-200 bg-rose-50 text-rose-500 text-xs font-semibold hover:bg-rose-100 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-edit-line text-xs"></i>
          עריכה
        </button>
        <button
          onClick={() => onToggleVisible(partner.id)}
          className="flex items-center justify-center px-3 py-2 rounded-xl border-2 border-amber-200 bg-amber-50 text-amber-500 text-xs font-semibold hover:bg-amber-100 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className={`${partner.visible ? 'ri-eye-off-line' : 'ri-eye-line'} text-sm`}></i>
        </button>
        <button
          onClick={() => onDelete(partner.id)}
          className="flex items-center justify-center px-3 py-2 rounded-xl border-2 border-gray-200 bg-gray-50 text-gray-400 hover:bg-red-50 hover:border-red-200 hover:text-red-400 transition-all cursor-pointer"
        >
          <i className="ri-delete-bin-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}
